import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface FooterTopBarProps {
  links: {
    label: string;
    to: string;
  }[];
}

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--distance-xxs);
  padding-bottom: var(--distance-m);
  background-color: var(--color-accent-background);
`;

const StyledLink = styled(Link)`
  color: var(--color-text-primary);
  font-size: var(--font-size-xs);
  line-height: var(--line-height-4xs);
  font-weight: var(--font-weight-bold);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;

const FooterTopBar = ({ links }: FooterTopBarProps) => {
  return (
    <StyledContainer>
      {links.map((link) => (
        <StyledLink key={link.label} to={link.to}>
          {link.label}
        </StyledLink>
      ))}
    </StyledContainer>
  );
};
export default FooterTopBar;
